import {translate} from "react-i18nify";

import * as componentTypes from "../constants/componentTypes";
import * as navigationActions from "./navigationActions";
import * as rccActions from "./rccActions";
import * as translationHelper from "../helpers/translationHelper";

const getStartDispensingAction = (tabId, dispensingAction, packageCount) => {
    return dispensingAction(tabId, packageCount);
};

const checkCanisterFullness = (tabId, dispensingAction, validation, colorantList, packageCount) => {
    if (validation !== null && validation.hasCriticalLevelForAllPackages()) {
        return navigationActions.openCheckBeforeDispensingModal(
            tabId,
            getStartDispensingAction(tabId, dispensingAction, packageCount),
            colorantList,
            packageCount
        );
    }

    return getStartDispensingAction(tabId, dispensingAction, packageCount);
};

const checkFormulaValidation = (
    tabId,
    dispensingAction,
    validation,
    dispenseWithErrors,
    colorantList,
    packageCount
) => {
    if (validation !== null && validation.isFormulaInvalid()) {
        return navigationActions.openConfirmationModal(
            tabId,
            dispenseWithErrors
                ? checkCanisterFullness(tabId, dispensingAction, validation, colorantList, packageCount)
                : null,
            translationHelper.getFormulaErrorTranslations(validation.getMainErrors()),
            translate("help.formulaValidation.warningConfirmBtn")
        );
    }

    return checkCanisterFullness(tabId, dispensingAction, validation, colorantList, packageCount);
};

const checkColorantBatch = (tabId, dispensingAction, validation, dispenseWithErrors, colorantList, packageCount) => {
    if (validation !== null && validation.isBatchNumberInvalid()) {
        return navigationActions.openBeforeDispenseColorantBatchModal(
            tabId,
            checkFormulaValidation(tabId, dispensingAction, validation, dispenseWithErrors, colorantList, packageCount),
            validation.getBatchNumberErrors()
        );
    }

    return checkFormulaValidation(tabId, dispensingAction, validation, dispenseWithErrors, colorantList, packageCount);
};

export const getValidationActionsSequence = (
    tabId,
    dispensingAction,
    validation,
    dispenseWithErrors,
    colorantList,
    packageCount
) =>
    navigationActions.userAuthentication(
        tabId,
        checkColorantBatch(tabId, dispensingAction, validation, dispenseWithErrors, colorantList, packageCount)
    );

const getStartQuickDispensingAction = (tabId) => {
    return rccActions.startQuickDispensing(tabId);
};

const checkCanisterFullnessBeforeQuickTint = (tabId, validation, colorantList, packageCount) => {
    if (validation !== null && validation.hasCriticalLevelForAllPackages()) {
        return navigationActions.openCheckBeforeDispensingModal(
            tabId,
            getStartQuickDispensingAction(tabId),
            colorantList,
            packageCount
        );
    }

    return getStartQuickDispensingAction(tabId);
};

const checkColorantBatchBeforeQuickDispensing = (tabId, validation, colorantList, packageCount) => {
    if (validation !== null && validation.isBatchNumberInvalid()) {
        return navigationActions.openBeforeDispenseColorantBatchModal(
            componentTypes.MODAL_NO_TAB,
            checkCanisterFullnessBeforeQuickTint(tabId, validation, colorantList, packageCount),
            validation.getBatchNumberErrors()
        );
    }

    return checkCanisterFullnessBeforeQuickTint(tabId, validation, colorantList, packageCount);
};

export const getQuickTintValidationActionsSequence = (tabId, validation, colorantList, packageCount) =>
    navigationActions.userAuthentication(
        tabId,
        checkColorantBatchBeforeQuickDispensing(tabId, validation, colorantList, packageCount)
    );
